module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0029.jpg?v=6bb6695b";